module.exports = __webpack_public_path__ + "img/developing-the-next-big-blockchain-app.b631dd51.png";